import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { handleUpdateBandData } from "../BandEditPage"
import { Band } from "../../types/bands"

interface IndoorsOutdoorsProps {
  band: Band
}

interface SelectOption {
  value: string | null
  label: string
}

interface ApiResponse {
  success: boolean
  errors?: {
    error: string
  }
}

export const IndoorsOutdoors: React.FC<IndoorsOutdoorsProps> = ({
  band,
}) => {
  const customOnSubmit = async (
    data: Record<string, any>,
  ): Promise<ApiResponse> => {
    // data will be { additional_info: { indoors_outdoors: value } } from EditBandFormField
    return (await handleUpdateBandData(band.id, {
      additional_info: { indoors_outdoors: data.additional_info?.indoors_outdoors || null },
    })) as ApiResponse
  }

  const options: SelectOption[] = [
    { value: null, label: "Select indoor/outdoor spaces..." },
    { value: "indoor_only", label: "Indoor Only" },
    { value: "outdoor_only", label: "Outdoor Only" },
    { value: "both", label: "Indoor and Outdoor Spaces" },
  ]

  const fieldData = {
    field: "additional_info.indoors_outdoors",
    name: "indoorsOutdoors",
    label: "Indoors/Outdoors",
    placeholder: "Select indoor/outdoor spaces",
    required: false,
  }

  return (
    <EditBandFormField
      type="select"
      fieldData={fieldData}
      bandId={band.id}
      options={options}
      onSubmit={customOnSubmit}
    />
  )
}

